import React from 'react';
import { Button, Modal, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';
import * as Icon from 'react-feather';
import { useTranslation } from 'react-i18next';

import { formatLicenseDate } from '../../utils/license';

// Shown on the login page when the login was refused for an expired licence. Static backdrop
// and no keyboard close: the only way out is the acknowledgement button.
const LicenseExpiredModal = ({ isOpen, expiryDate, onClose }) => {
  const { t } = useTranslation();
  const date = formatLicenseDate(expiryDate);

  return (
    <Modal isOpen={isOpen} size="md" centered backdrop="static" keyboard={false}>
      <ModalBody>
        <div className="d-flex flex-column justify-content-between align-items-center pt-4 text-center">
          <Icon.Lock size={60} className="text-danger" />
          <div className="fs-4 pt-2 text-dark">{t('licenseExpiredTitle')}</div>
          <div className="fs-6 pt-2">
            {date ? t('licenseExpiredMessage', { date }) : t('licenseExpiredMessageNoDate')}
          </div>
        </div>
      </ModalBody>
      <ModalFooter className="justify-content-center">
        <Button onClick={onClose} className="px-5 bg-danger border-danger">
          {t('ok')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

LicenseExpiredModal.propTypes = {
  isOpen: PropTypes.bool,
  expiryDate: PropTypes.string,
  onClose: PropTypes.func
};

export default LicenseExpiredModal;
